module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"active":"Active","add_deployment":"Add Deployment","created":"Created: {date}","devices_monitored":"{count} devices monitored","devices_monitored_limit":"{count} / {limit} devices monitored","expired":"Expired","renews":"Renews: {date}","subscription":"Subscription: {status}","trial":"Trial"}}')
  delete Component.options._Ctor
}
